/**
 * 系统配置
 */
export default {
  /**
   * 系统默认语言
   */
  defaultLang: "en_US",
};
